module.exports = __webpack_public_path__ + "img/france3.cffcfed8.jpg";